// Import external
import { Component, Input, OnInit } from '@angular/core';

// Import internal
import { Company } from '@data/models/company.model';

@Component({

    selector: 'syn-company-avatar',
    templateUrl: 'company-avatar.component.html'
})
export class CompanyAvatarComponent implements OnInit {
    @Input() company: Pick<Company, 'id' | 'name'>;
    @Input() titleInfos = '';
    @Input() showLegend = false;
    @Input() showId = false;
    @Input() caption = '';
    @Input() size = 32;
    @Input() legend = '';
    @Input() clickable = true;
    @Input() tooltip = false;
    @Input() backgroundColor: string;
    @Input() iconColor: string;

    public title = '';
    public text = '';
    public link = '/companies/';

    ngOnInit() {
        const name = this.company.name;
        const legend = this.legend || name;
        this.title = this.titleInfos ? legend + ' (' + this.titleInfos + ')' : legend;
        this.text = !this.showLegend ? this.showId ? this.company.id : '' : name;
        this.link += this.company.id;
    }
}
